export default class ShowMoreButtonConstructor {
  createButton(buttonLabel: string): HTMLElement {
    const showMoreButton = document.createElement('button');

    showMoreButton.classList.add('show-more-button');
    showMoreButton.innerText = buttonLabel;

    return showMoreButton;
  }
}
